var map = {
	"./template.betgalaxy": 2113,
	"./template.betgalaxy.tsx": 2113,
	"./template.betprofessor": 1062,
	"./template.betprofessor.tsx": 1062,
	"./template.betroyale": 1063,
	"./template.betroyale.tsx": 1063,
	"./template.default": 656,
	"./template.default.tsx": 656,
	"./template.fiestabet": 1064,
	"./template.fiestabet.tsx": 1064,
	"./template.puntcity": 1065,
	"./template.puntcity.tsx": 1065,
	"./template.puntgenie": 1066,
	"./template.puntgenie.tsx": 1066,
	"./template.questbet": 1067,
	"./template.questbet.tsx": 1067,
	"./template.ts": 965,
	"./template.volcanobet": 1068,
	"./template.volcanobet.tsx": 1068,
	"./template.wellbet": 1069,
	"./template.wellbet.tsx": 1069
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2419;